import { Domain, V2ChatHistoryApiResponse } from "../../api";

export type HistoryMetaData = { id: string; title: string; timestamp: number };

export const enum HistoryProviderOptions {
    None = "none",
    CosmosDB = "cosmosDB"
}

export interface GiveFeedbackParams {
    conversationId: string;
    positive: boolean;
    turnIndex: number;
    comment?: string;
    idToken?: string;
    reason?: string;
}

export interface IHistoryProvider {
    getProviderName(): HistoryProviderOptions;
    resetContinuationToken(): void;
    getNextItems(count: number, idToken?: string, domain?: Domain): Promise<HistoryMetaData[]>;
    getItem(id: string, idToken?: string): Promise<V2ChatHistoryApiResponse | null>;
    deleteItem(id: string, idToken?: string): Promise<void>;
    giveFeedback({ conversationId, positive, turnIndex, comment, idToken }: GiveFeedbackParams): Promise<void>;
}
